let googleMapsPromise = null;

function waitForGoogleMapsReady(resolve, reject, startTime) {
  const elapsed = Date.now() - startTime;

  if (window.google && window.google.maps && typeof window.google.maps.Map === "function") {
    resolve(window.google);
    return;
  }

  if (elapsed > 15000) {
    reject(new Error("Google Maps API loaded but not ready (timeout). Check API key/restrictions."));
    return;
  }

  setTimeout(() => waitForGoogleMapsReady(resolve, reject, startTime), 50);
}

/**
 * Loads Google Maps JS API once.
 * Requires env: REACT_APP_GOOGLE_MAPS_KEY
 * @param {string[]} libraries e.g. ['drawing']
 */
export function loadGoogleMaps(libraries = ["drawing"]) {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("window not available"));
  }

  // Already loaded and ready
  if (window.google && window.google.maps && typeof window.google.maps.Map === "function") {
    return Promise.resolve(window.google);
  }

  if (googleMapsPromise) return googleMapsPromise;

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;
  if (!apiKey) {
    return Promise.reject(
      new Error("Missing REACT_APP_GOOGLE_MAPS_KEY. Add it in .env and restart the UI.")
    );
  }

  googleMapsPromise = new Promise((resolve, reject) => {
    const scriptId = "google-maps-js";
    const existing = document.getElementById(scriptId);

    // If script already exists, just wait for readiness
    if (existing) {
      waitForGoogleMapsReady(resolve, reject, Date.now());
      return;
    }

    const script = document.createElement("script");
    script.id = scriptId;
    script.async = true;
    script.defer = true;

    const libs = (libraries || []).join(",");
    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}` +
      `&v=3.64` +
      `&libraries=${encodeURIComponent(libs)}` +
      `&loading=async`;

    script.onload = () => {
      waitForGoogleMapsReady(resolve, reject, Date.now());
    };

    script.onerror = () => {
      reject(new Error("Google Maps failed to load. Check network / key restrictions."));
    };

    document.head.appendChild(script);
  });

  return googleMapsPromise;
}
